import { __extends } from "tslib";
import { ListBucketMetricsConfigurationsOutput, ListBucketMetricsConfigurationsRequest } from "../models/index";
import { deserializeAws_restXmlListBucketMetricsConfigurationsCommand, serializeAws_restXmlListBucketMetricsConfigurationsCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var ListBucketMetricsConfigurationsCommand = /** @class */ (function (_super) {
    __extends(ListBucketMetricsConfigurationsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListBucketMetricsConfigurationsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    ListBucketMetricsConfigurationsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: ListBucketMetricsConfigurationsRequest.filterSensitiveLog,
            outputFilterSensitiveLog: ListBucketMetricsConfigurationsOutput.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListBucketMetricsConfigurationsCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlListBucketMetricsConfigurationsCommand(input, context);
    };
    ListBucketMetricsConfigurationsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlListBucketMetricsConfigurationsCommand(output, context);
    };
    return ListBucketMetricsConfigurationsCommand;
}($Command));
export { ListBucketMetricsConfigurationsCommand };
//# sourceMappingURL=ListBucketMetricsConfigurationsCommand.js.map